
import { defineComponent, PropType, watch, nextTick } from 'vue'
import { zh_tran } from '@/utils/lang.js'
import { StrategyItem } from './StrategyTable.vue'

export default defineComponent({
  name: 'StrategyInfo',
  props: {
    strategy: { type: Object as PropType<StrategyItem | null>, default: null },
    isTraditional: { type: Boolean, default: false }
  },
  setup(props) {
    function tran(text: string) {
      if (props.isTraditional) {
        return (text as any).tran()
      }
      return text
    }

    function switchLanguage() {
      if (props.isTraditional) {
        nextTick(() => zh_tran('t'))
      }
    }

    // 策略切换时重新触发 DOM 转换（name/tags/profile 是接口数据）
    watch(() => props.strategy, () => switchLanguage())

    return { tran }
  }
})
